import { Box, Heading, Text, Thumbnail } from '@wix/design-system';
import React, { type FC } from 'react';
import type { DeploymentHostTypeConfig, SelfHostedModalState } from '../types';
import type { DeploymentHostType } from '@wix/ambassador-devcenter-apps-v1-app-template/types';

type DeploymentOptionProps = DeploymentHostTypeConfig & {
  selected: SelfHostedModalState['selectedDeploymentProvider'];
  setSelected: (id: DeploymentHostType) => void;
};

export const DeploymentOption: FC<DeploymentOptionProps> = ({
  title,
  subtitle,
  image,
  id,
  selected,
  setSelected,
}) => {
  return (
    <Thumbnail
      dataHook={id}
      selected={selected === id}
      onClick={() => setSelected(id)}
    >
      <Box padding="18px">
        <Box gap="12px" verticalAlign="middle">
          <img alt="" src={image} />
          <Box direction="vertical">
            <Heading size="tiny">{title}</Heading>
            <Box>
              <Text size="small" secondary>
                {subtitle}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Thumbnail>
  );
};
